import { LoaderSpinnerComponent } from '@aston/foundation/components';
import { Component, OnInit } from '@angular/core';
import { delay, takeUntil } from 'rxjs/operators';

import { LoginPageComponent } from '../login-page/login-page.component';
import * as RoutesDefinitions from '../../../routes-definitions';
import { AppConstants } from '../../../app.constants';

@Component({
	selector: 'login-callback-page',
	template: `<loader-spinner [model]="formLoader" />`,
	imports: [LoaderSpinnerComponent]
})
export class LoginCallbackPageComponent extends LoginPageComponent implements OnInit {

	ngOnInit() {
		const redirectUrlVar = AppConstants.LOCALSTORAGE_KEYS.REDIRECT_URL;

		this.activatedRoute.queryParams.pipe(
			takeUntil(this.destroySubscriptions$)
		).subscribe(params => {
			this.authenticationService.getIsAuthorized().pipe(delay(0)).subscribe(isAuth => {
				if (isAuth) {
					const queryParams = { [redirectUrlVar]: params[redirectUrlVar] };
					this.router.navigate([RoutesDefinitions.getHomeFullPath()], { queryParams });

				} else {
					this.router.navigate([RoutesDefinitions.getLoginFullPath()]);
				}
			});
		})
	}
}
